import { Component, OnInit , AfterViewInit , Input } from '@angular/core';
import {CommonService} from "../common.service";
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-leader-talk',
  templateUrl: './leader-talk.component.html',
  styleUrls: ['./leader-talk.component.css']
})
export class LeaderTalkComponent implements OnInit , AfterViewInit{
    @Input() talk:string;
    @Input() headImageUrl:string;
    @Input() learningPathMetaId:number;
    isHarmonyOS = false; //是否鸿蒙系统
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.isHarmonyOS = this.commonService.isHarmonyOS();
  }

  ngAfterViewInit(){
      let htmlFontSize=document.documentElement.clientWidth/7.5;
      document.documentElement.style.fontSize=htmlFontSize+"px";

      if (this.headImageUrl) {
        $("#leader_talk_wrap #picture").css("background-image", "url(" + this.headImageUrl + ")");
      }

      if(this.talk.length>13){
          $(".talk_item").last().width($("#test").width());
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/leader-talk/leader-talk.component.ts